angular
  .module('components.auth', [
    'ui.router',
    'firebase'
  ])
  .config(function ($firebaseRefProvider) {

    var config = {
      apiKey: "AIzaSyCDyOduisozwlwLUXNzis7SjuxXR5T-kDw",
      authDomain: "contacts-manager-df64c.firebaseapp.com",
      databaseURL: "https://contacts-manager-df64c.firebaseio.com",
      projectId: "contacts-manager-df64c",
      storageBucket: "contacts-manager-df64c.appspot.com",
      messagingSenderId: "295561666392"
    };

    $firebaseRefProvider
      .registerUrl({
        default: config.databaseURL,
        contacts: config.databaseURL + '/contacts'
      });

    firebase.initializeApp(config);
  })
  .run(function ($transitions, $state, AuthService) {
    $transitions.onStart({
      to: function (state) {
        return !!(state.data && state.data.requiredAuth);
      }
    }, function() {
      return AuthService
        .requireAuthentication()
        .catch(function () {
          return $state.target('auth.login');
        });
    });
    $transitions.onStart({
      to: 'auth.*'
    }, function () {
      if (AuthService.isAuthenticated()) {
        return $state.target('app');
      }
    });
  });
